/**
 * Loader JavaScript singleton module
 */

var Loader = (function($) {

  function initLoader() {

    var paramsLoader = {
        container: document.getElementById('loader'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        rendererSettings: {
        progressiveLoad:false,
        preserveAspectRatio: 'xMidYMid meet'
        },
        path: '/wp-content/themes/eaas/inc/json/data-loader.json'
    };
    
    var animationLoader;
    animationLoader = lottie.loadAnimation(paramsLoader);

    setTimeout(function(){ 
        $('body').addClass('loaded');
    }, 200);
    
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.loader').length) {
      return;
    }

    initLoader();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Loader.init);


